import { Clock } from "lucide-react";
import { Stamp } from "./kit";

export default function LastContact({ contact: c, className = "", testid }) {
  if (!c.last_contacted) return <span className={`text-[11px] text-amber-600 flex items-center gap-1 ${className}`} data-testid={testid}><Clock className="w-3 h-3" />No contact yet</span>;
  return <Stamp prefix="Last contact" at={c.last_contacted} icon={Clock} className={className} testid={testid} />;
}
